export const en = {
  $vuetify: {
    // C
    close: 'Close',
    chooseOption: 'Choose an option',

    // Q
    qrcodeSummary: 'Scan the QR code with your smartphone to see the product in augmented reality',

    // S
    seeInAR: 'See in AR',
  },
}
